import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AccessTerminated from '../commons/icons/access_terminated';
import { HeaderContainer } from '../../app/common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import {
  AccessLine,
  ButtonContainer,
  ButtonWrapper,
  Description,
  LastLine,
  OuterRing,
  QueryLine,
  SupportLink,
  UnderLine,
} from './AccessDenied.styled';
import { Body5, Headline3 } from '../../app/common/typography';
import { ButtonLarge } from '../../app/common/sharedComponents/buttons/ButtonLarge';

interface AccessDeniedProps {
  tabname: string;
}
const AccessDenied = ({ tabname }: AccessDeniedProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <HeaderContainer>
        <AppHeader title={tabname} hasBackButton={false} />
      </HeaderContainer>
      <OuterRing>
        <AccessTerminated />
      </OuterRing>
      <AccessLine>
        <Headline3>{t('COMMON.ERROR_BOUNDARIES.HOTEL_ACCESS.TITLE')}</Headline3>
      </AccessLine>
      <Description>
        <Body5>
          {t('COMMON.ERROR_BOUNDARIES.HOTEL_ACCESS.MEMBERSHIP_AND_LEARNING')}
        </Body5>
      </Description>
      <QueryLine>
        <Body5>
          {t('COMMON.ERROR_BOUNDARIES.HOTEL_ACCESS.REMAIN_ACCESSIBLE')}
        </Body5>
      </QueryLine>
      <LastLine>
        <QueryLine>
          <Body5>
            {t('COMMON.ERROR_BOUNDARIES.HOTEL_ACCESS.FOR_INQUIRES')}
          </Body5>
        </QueryLine>
        <QueryLine>
          <Body5>
            {t('COMMON.ERROR_BOUNDARIES.HOTEL_ACCESS.ADMINISTRATION_OR')}{' '}
            <SupportLink to={'mailto:support@mylqa.com'}>
              <UnderLine>
                <i>my</i>LQA support.
              </UnderLine>{' '}
            </SupportLink>
          </Body5>
        </QueryLine>
      </LastLine>
      <LastLine>
        <QueryLine>
          <Body5>{t('COMMON.ERROR_BOUNDARIES.HOTEL_ACCESS.MESSAGE')}</Body5>
        </QueryLine>
      </LastLine>
      <ButtonContainer>
        <ButtonWrapper>
          <ButtonLarge
            title={t('COMMON.OUTSIDE.BUTTONS.ENTER_ACTIVATION_CODE')}
            onClick={() => {
              navigate('/register/activationCode', {
                state: {
                  isDeactivatedUser: true,
                },
              });
            }}
          />
        </ButtonWrapper>
      </ButtonContainer>
    </>
  );
};

export default AccessDenied;
